import { isBefore, parseISO, startOfDay } from "date-fns"
import { getTimeRange, TimeFrame, TimeFrameEnum } from "schema"

export const BACKOFFICE_ACTIVITY_TIME_FRAME = TimeFrameEnum.Last30Days

const FADED_ACTIVITY_OPACITY = 0.5

export function getBackofficeActivityOpacity(
  date: string | Date | null | undefined,
  timeFrame: TimeFrame,
) {
  if (!date) return 1

  const rangeStart = startOfDay(getTimeRange(timeFrame).from)
  const activityDate = startOfDay(typeof date === "string" ? parseISO(date) : date)

  return isBefore(activityDate, rangeStart) ? FADED_ACTIVITY_OPACITY : 1
}
